// External Dependencies
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

// Internal Dependencies
import OpeningHoursBase from '../../openingHours/openingHours';
import OverLoading from '../../global/OverLoading';
import apiService from '../../../services.js/apiService';
import { IsEmpty } from '../../../common/checks';
import { Status } from '../../../common/constants';
import MButton from '../../common/MButton';
import Colours from '../../../styles/colours';

const OpeningHoursPage = ({ match }) => {
  const [poiData, setPoiData] = useState(null);
  const [loading, setIsLoading] = useState(true);

  const [childComponent, setChildComponent] = useState(null);

  const handleChildRef = (ref) => {
    setChildComponent(ref);
  };

  function extractOpeningHours(data) {
    if (data && data.default.length > 0) {
      const allHours = data.default
        .filter((day) => day.hours && day.hours.length > 0)
        .map((day) => day.hours)
        .flat();
      return allHours;
    }

    return [];
  }

  const getPoiData = async (id) => {
    try {
      if (IsEmpty(id)) {
        return null;
      }
      setIsLoading(true);
      const poi = await apiService.getPoi(id);
      setPoiData(poi);

      const uniqueHoursData = extractOpeningHours(poi.openingHours);

      return { ...poi, uniqueOpenHours: uniqueHoursData };
    } catch (err) {
      toast.error(err.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    if (childComponent) {
      await childComponent.onSubmit(e);
    }
  };

  const updatePoiData = async (data, id) => {
    try {
      setIsLoading(true);
      const res = await apiService.updatePoi(id, data);
      toast.success('Opening hours updated');
      setPoiData(res);
      return res;
    } catch (err) {
      toast.error(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (match.params.id) {
      getPoiData(match.params.id);
    }
  }, [match.params.id]);

  if (loading && !poiData) {
    return <OverLoading />;
  }

  return (
    <div>
      <div className="col-md-12">
        <OpeningHoursBase
          childRef={handleChildRef}
          match={match}
          params={match.params}
          id={match.params.id}
          hasExceptions={false}
          getEntity={getPoiData}
          updateEntity={updatePoiData}
          dataOpening={poiData.openingHours}
          uniqueOpenHours={poiData.uniqueOpenHours}
        />
      </div>
      <div className="mt-5 col-md-6 d-flex flex-column">
        <MButton
          colour={poiData.status === Status.Deactivated ? Colours.Gray : Colours.Primary}
          onClick={handleSubmit}
          text="Save"
          textColour={Colours.White}
          disabled={poiData.status === Status.Deactivated}
        />
      </div>
    </div>
  );
};

OpeningHoursPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default OpeningHoursPage;
